import { useSelector } from 'react-redux'

export function useIsFrontend() {
    return useSelector(({ app }) => app?.frontend)
}

export function useIsLoggedIn() {
    return useSelector(({ app }) => app.logged_in || !!app.current_user?.id)
}
